import { types, flow, getSnapshot } from 'mobx-state-tree';
import { navigate } from 'js/services/Network';
import { pick } from 'lodash';

import { makeRequest, url, errorResponse } from 'js/services/Network';
import { castEventToValue } from 'js/services/FormTools';
import analytics from 'js/services/Analytics';
import AnonymousId from 'js/services/AnonymousId';

import SteppedPage from 'js/stores/SteppedPage';
import Address from '../types/Address';
import AppState from "js/stores/AppState";

const CreatePaymentLinkPageState = types
  .model('CreatePaymentLinkPage', {
    isSubmitting: false,
    modalIsVisible: false,
    error: types.maybeNull(types.string),
    anonymous_id: AnonymousId,

    isHoveringFiles: false,
    isUploadingFiles: false,
    uploadFilesError: '',

    hasEnteredTitle: false,
    hasEnteredPrice: false,
    hasEnteredQuantity: false,

    primary_image: '',
    title: '',
    price: '',
    quantity: '1',
    size: '',
    address: types.optional(Address, {}),
    withSignup: false,
  })
  .actions(self => {
    return {
      getStepRoute(step) {
        return url('create-payment-link-page', {
          step,
        });
      },

      initStep(step) {
        self.modalIsVisible = false;
        return self;
      },

      load: flow(function* load() {
        const response = yield makeRequest('create-payment-link-data', self);
        self.address = response.data.address || {};
        self.title = new URLSearchParams(window.location.search).get('title') || '';
        self.hasEnteredTitle = self.title.length > 0;
      }),

      submit: flow(function* submit() {
        let response;
        if (!self.isSubmitting) {
          self.isSubmitting = true;
          self.error = null;

          try {
            response = yield makeRequest(
              'create-payment-link',
              null,
              pick(self, ['title', 'price', 'size', 'quantity', 'address', 'anonymous_id']),
            );

            const alias = response.data.alias;

            analytics
              .track('Offer Link Created', {
                'Item Price': self.price,
                'Item Name': self.title,
                'Item Quantity': self.quantity || '1',
                'Item Size': self.size,
                'Payment Link': url('checkout-page', { alias }),
                'Location': AppState.currentPage,
                'Event Initiated by': AppState.currentPage === 'CreatePaymentLinkPage' || AppState.currentPage === 'SellerLandingPage'
                  ? 'seller' : 'buyer'
              });


            navigate(url(self.withSignup ? 'seller-payment-link-page' : 'manage-item-page', { alias }));
          } catch (error) {
            self.error = errorResponse(error);
          }

          self.isSubmitting = false;
        }
        return response;
      }),

      setWithSignup(withSignup) {
        self.withSignup = withSignup;
        return self;
      },
      setError(message) {
        self.error = message;
        return self;
      },
      onUpload(image_url) {
        self.primary_image = image_url;
      },
      openModal() {
        self.modalIsVisible = true;
        return self;
      },
      closeModal() {
        self.modalIsVisible = false;
        return self;
      },

      nextDetail() {
        if (!self.hasEnteredTitle && self.title) {
          self.hasEnteredTitle = true;
        } else if (!self.hasEnteredPrice && self.price && parseInt(self.price) > 0) {
          self.hasEnteredPrice = true;
        } else if (!self.hasEnteredQuantity && self.quantity && parseInt(self.quantity) > 0) {
          self.hasEnteredQuantity = true;
        } else {
          self.nextStep();
        }
      },
      setTitle(title) {
        self.title = castEventToValue(title);
      },
      setPrice(price) {
        self.price = castEventToValue(price);
      },
      setQuantity(quantity) {
        self.quantity = castEventToValue(quantity);
      },
      setSize(size) {
        self.size = castEventToValue(size);
        console.log(size, self.size)
        return self;
      },
      addressSaved(savedAddress) {
        self.address.setAddress(getSnapshot(savedAddress));
        self.modalIsVisible = false;
      },
    };
  });

export default types.compose(
  SteppedPage,
  CreatePaymentLinkPageState,
);
